import script from "./CrmClte.vue?vue&type=script&lang=ts&setup=true"
export * from "./CrmClte.vue?vue&type=script&lang=ts&setup=true"

import "./CrmClte.vue?vue&type=style&index=0&id=3e78c88c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e78c88c"]])

export default __exports__